(function ($) {
  'use strict';

    var Idle = function(element, options) {
        this.init(element, options);
    };

    Idle.DEFAULTS = {
        idle: 60000, //idle time in ms
        events: 'mousemove keydown mousedown touchstart', //events that will trigger the idle resetter
        onIdle: function () {}, //callback function to be executed after idle time
        onActive: function () {}, //callback function to be executed after back from idleness
        onHide: function () {}, //callback function to be executed when window is hidden
        onShow: function () {}, //callback function to be executed when window is visible
        keepTracking: true, //set it to false if you want to track only the first time
        startAtIdle: false,
        recurIdleCall: false
    };

    Idle.prototype.init = function (element, options) {
        this.$element = $(element);
        this.options = options = $.extend({}, Idle.DEFAULTS, options);
        this.isIdle = options.startAtIdle || false;

        var visible = !options.startAtIdle || true;

        if(options.startAtIdle) this.lastId = this.timeout();

        this.$element.on(options.events, $.proxy(this.resetTimeout, this));

        if (options.onShow || options.onHide) {
            var self = this;
            $(document).on('visibilitychange webkitvisibilitychange mozvisibilitychange msvisibilitychange', function () {
                if (document.hidden || document.webkitHidden || document.mozHidden || document.msHidden) {
                    if (visible) {
                        visible = false;
                        options.onHide.call(self.$element);
                    }
                } else {
                    if (!visible) {
                        visible = true;
                        options.onShow.call(self.$element);
                    }
                }
            });
        }
    };

    Idle.prototype.resetTimeout = function() {
        if (this.isIdle) {
            this.isIdle = false;
            this.options.onActive.call();
        }
        clearTimeout(this.lastId);

        if(this.options.keepTracking) this.lastId = this.timeout();
    };

    Idle.prototype.clearTimeout = function() {
        clearTimeout(this.lastId);
    };

    Idle.prototype.timeout = function() {
        var self = this
            ,timer = (this.options.recurIdleCall ? setInterval : setTimeout)
            , id = timer(function () {
                self.isIdle = true;
                self.options.onIdle.call(self.$element);
            }, this.options.idle);

        return id;
    };

    Idle.prototype.destroy = function() {
        this.$element.off(this.options.events);
        this.options.keepTracking = false;
        this.resetTimeout();
        this.$element.removeData('idle');
    };

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this)
                ,data = $this.data('idle')
                ,options = typeof option == 'object' && option;

            if (!data && option == 'destroy') return;
            if (!data) $this.data('idle', (data = new Idle(this, options)));
            if (typeof option == 'string') data[option]();
        });
    }

    $.fn.idle = Plugin;
    $.fn.idle.Constructor = Idle;
}(jQuery));
